export function buildDealMaxCacOptions(deals) {
  const options = [];
  const seenMaxCac = new Set();

  (deals || []).forEach((deal) => {
    const maxCac = Number(deal?.maxCac);
    if (!(maxCac > 0) || seenMaxCac.has(maxCac)) {
      return;
    }
    seenMaxCac.add(maxCac);
    options.push({
      id: deal.id,
      name: deal.name,
      maxCac,
    });
  });

  return options;
}
